import { ACCOUNT_TYPES } from '#client/constants/accountTypes';
import * as ROUTES from '#client/constants/routes';

const USER_MENU_ITEM_IDS = {
  ACCOUNT_SETTINGS: 'account-settings',
  BILLING: 'billing',
  GET_HELP: 'get-help',
  LOG_OUT: 'log-out'
};

const USER_MENU_ITEMS = {
  [USER_MENU_ITEM_IDS.ACCOUNT_SETTINGS]: {
    icon: { alt: 'settings', src: 'settings-outline.svg' },
    path: ROUTES.accountSettings,
    title: 'account settings'
  },
  [USER_MENU_ITEM_IDS.BILLING]: {
    icon: { alt: 'payment', src: 'credit-card-outline.svg' },
    path: ROUTES.billingPaymentMethods,
    title: 'billing'
  },
  [USER_MENU_ITEM_IDS.GET_HELP]: {
    icon: { alt: 'help', src: 'question-mark-outline.svg' },
    path: ROUTES.help,
    title: 'get help'
  },
  [USER_MENU_ITEM_IDS.LOG_OUT]: {
    divider: 'top',
    icon: { alt: 'logout', src: 'logout-outline.svg' },
    path: ROUTES.logout,
    title: 'log out'
  }
};

const USER_MENU_CONFIGS = {
  [ACCOUNT_TYPES.ENTERPRISE]: [
    USER_MENU_ITEM_IDS.GET_HELP,
    USER_MENU_ITEM_IDS.LOG_OUT
  ],
  [ACCOUNT_TYPES.STANDARD]: [
    USER_MENU_ITEM_IDS.ACCOUNT_SETTINGS,
    USER_MENU_ITEM_IDS.BILLING,
    USER_MENU_ITEM_IDS.GET_HELP,
    USER_MENU_ITEM_IDS.LOG_OUT
  ]
};

export function getUserMenuConfig(configId) {
  const menuItemIds = USER_MENU_CONFIGS[configId]
    ?? USER_MENU_CONFIGS[ACCOUNT_TYPES.STANDARD];

  return menuItemIds.map((itemId) => ({
    id: itemId,
    ...USER_MENU_ITEMS[itemId]
  }));
}
